import api from 'services/api';
import { checkId } from 'services/common';
import { GET, POST, PUT, DELETE, categoryRoutes } from 'constants/api';

const checkCategoryId = categoryId => {
  checkId(categoryId, 'Category id is missing');
};

export const getCategories = () =>
  api({
    method: GET,
    url: categoryRoutes.GET_CATEGORIES,
  });

export const getCategoryById = categoryId => {
  checkCategoryId(categoryId);
  return api({
    method: GET,
    url: `${categoryRoutes.GET_CATEGORIES}${categoryId}`,
  });
};

export const addCategory = data =>
  api({
    method: POST,
    url: categoryRoutes.ADD_CATEGORY,
    data,
  });

export const editCategory = data => {
  checkCategoryId(data.id);
  return api({
    method: PUT,
    url: `${categoryRoutes.EDIT_CATEGORY}${data.id}`,
    data,
  });
};

export const deleteCategory = categoryId => {
  checkCategoryId(categoryId);
  return api({
    method: DELETE,
    url: `${categoryRoutes.DELETE_CATEGORY}${categoryId}`,
  });
};
